import { Activity, getActivities } from "apis/card.api";
import { AxiosError } from "axios";
import { useQuery } from "react-query";
import { ServerState } from "utils/serverState";

export const useActivities = () =>
  useQuery<Activity[], AxiosError>(ServerState.ACTIVITIES, () =>
    getActivities()
  );
